export default __webpack_public_path__ + "static/media/icons.e98dda91.svg";